import { useMutation } from '@tanstack/react-query';

import { CreateConversationResponse, createConversation } from '~/services/AIChatService';

export function useCreateChatConversation() {
  return useMutation<CreateConversationResponse, Error>({
    mutationFn: createConversation,
  });
}
